<template>
  <div class="on-boarding-window" ref="onBoarding">
    <div class="on-boarding-window__stage window-stage" v-if="isShowLargeWindow">
      <div class="window-stage__header">
        <h4 class="window-stage__title">{{title}}</h4>
        <button
          class="window-stage__close-button"
          type="button"
          title="Свернуть окно"
          @click="isShowLargeWindow = !isShowLargeWindow" />
      </div>
      <ul class="window-stage__list">
        <li
          v-for="item in preparedListSteps"
          v-bind:key="item.id"
          class="window-stage__item"
          :class="{ 'window-stage__item--done': item.isPassed }"
          :aria-label="getPassedMessage(item.isPassed) "
        >
          <router-link
            v-bind:to="item.linkAnchor"
            v-show="item.isAccess"
          >
            {{item.name}}
          </router-link>
        </li>
      </ul>
    </div>
    <div
      v-else
      class="on-boarding-window__wrapper-buttons">
      <button
        class="on-boarding-window__close-cross"
        type="button"
        title="Закрыть окно"
        aria-label="Закрыть окно настроек"
        @click="onCloseWindow" />
      <button
        class="on-boarding-window__open-window"
        type="button"
        @click="isShowLargeWindow = !isShowLargeWindow">
        {{title}}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    title() {
      return this.$store.getters.getTitle;
    },
    preparedListSteps() {
      return this.listSteps.filter((el) => el.isAccess && !el.isHide);
    },
  },
  props: {
    /**
     * Список целей
     */
    listSteps: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      /**
       * Показать окно
       *
       */
      isShowLargeWindow: false,
    };
  },
  methods: {
    /**
     * Получить сообщение о состоянии шага
     *
     * @param condition {bool}
     * @return {string}
     */
    getPassedMessage(condition) {
      return condition ? 'Выполнен' : 'Не выполнен';
    },
    /**
     * Закрыть окно быстрых настроек
     * @return {void}
     */
    onCloseWindow() {
      this.$refs.onBoarding.style = 'display: none';
    },
  },
};
</script>
<style scoped lang="scss">
.on-boarding-window {
  position: fixed;
  z-index: 4;
  color: white;
  right: 60px;
  bottom: 50px;
  &__stage {
    background-color: var(--primary-background-color);
    border-radius: 10px;
    padding: 20px;
  }
  &__close-cross {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 23px;
    height: 23px;
    mask-image: url("@/assets/img/exit-grey-min.svg");
    mask-size: 23px;
    background-color: #ffffff;
  }
  &__open-window {
    padding: 29px 20px;
    width: 300px;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    color: white;
    border-radius: 20px;
    background-color: #357ebd;
  }
}

.window-stage {
  border: 1px solid #357ebd;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  &__header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 38px;
  }
  &__title {
    font-size: 16px;
    font-weight: 700;
    color: #357ebd;
  }
  &__close-button {
    width: 15px;
    height: 20px;
    background: url("@/assets/img/arrow/arrow-blue.svg") no-repeat center;
    background-size: 9px 15px;
    rotate: 270deg;
  }
  &__list {
    display: grid;
    row-gap: 16px;
    margin: 0;
    padding: 0;
    font-size: 12px;
    text-align: center;
  }
  &__item {
    display: flex;
    align-items: center;
    gap: 8px;
    &::before {
      content: '';
      flex-shrink: 0;
      width: 34px;
      height: 34px;
      background-color: #ffffff;
      border: 1px solid #357ebd;
      border-radius: 50%;
    }
    &--done::before {
      border: none;
      background: #357ebd url("@/assets/img/checked/double-checked-white.svg") no-repeat center;
      background-size: 17px 14px;
    }
    > a {
      font-size: 16px;
      font-weight: 400;
      color: #000000;
      text-align: left;
      text-decoration: none;
      transition: 0.3s;
      @media (hover: hover) {
        &:hover {
          color: #357ebd;
        }
      }
      &:active {
        opacity: 0.6;
      }
    }
  }
}

@media screen and (max-width: 960px) {
  .on-boarding-window {
    bottom: 100px;
  }
}

@media screen and (max-width: 480px) {
  .on-boarding-window {
    left: 25px;
    right: 25px;
    bottom: 50px;
    &__open-window {
      padding: 18px 12px;
      width: 100%;
    }
  }
}
</style>
